import { requestApi } from "../../utils/requestApi";
import { GET, POST } from "../../types/httpMethod";
import { message } from "antd";
import { I18n } from "react-redux-i18n";
import { debug } from "../../utils/debug";

export const getAllTemplates = async (): Promise<any> => {
  try {
    return requestApi(GET, "survey-template/templates", {}, false, false);
  } catch (e) {
    debug.error(e);
  }
};

export const createSurveyFromTemplate = async (templateId: string) => {
  try {
    const res = await requestApi(POST, `surveys/from-template/${templateId}`, {}, false, false);
    message.success(I18n.t("surveyCreatedFromTemplate"));
    return res;
  } catch (e: any) {
    if (e?.response?.status === 429) {
      message.error(I18n.t("youHaveReachedMaxSurveys"));
    }
    debug.error(e);
  }
};
